import { render, staticRenderFns } from "./DefaultPlanEdit.vue?vue&type=template&id=722bb704&"
import script from "./DefaultPlanEdit.vue?vue&type=script&lang=js&"
export * from "./DefaultPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports